import * as React from 'react';
import { IsLoggedIn } from '@grandvisionhq/auth';
import { useIntl } from '@grandvisionhq/state';
import { useStoreFinderContext } from '../../context/StoreFinder/context.js';
import PreferredStoreTile from '../PreferredStoreTile/PreferredStoreTile.js';
import HighlightPreferredStore from './HighlightPreferredStore.js';
import useGetPreferredStore from '../../hooks/api/use-get-preferred-store.js';

const HighlightPreferredStoreContainer = ()=>{
    const { getLabel  } = useIntl();
    const { setPreferredStore  } = useStoreFinderContext();
    const { data: store  } = useGetPreferredStore();
    const title = getLabel('stores.component.storeFinder.preferredStoreTile.title');
    React.useEffect(()=>{
        if (store) {
            setPreferredStore(store);
        }
    }, [
        store,
        setPreferredStore
    ]);
    if (!store) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(HighlightPreferredStore, {
        title: title
    }, /*#__PURE__*/ React.createElement(PreferredStoreTile, {
        store: store
    }));
};
var HighlightPreferredStoreContainer$1 = (()=>/*#__PURE__*/ React.createElement(IsLoggedIn, null, /*#__PURE__*/ React.createElement(HighlightPreferredStoreContainer, null))
);

export { HighlightPreferredStoreContainer$1 as default };
//# sourceMappingURL=HighlightPreferredStoreContainer.js.map
